const allowedUserIds = ["2D9BFUVY", "MN34OP56", "OP12QR34", "C8J1P6DR", "WSORODTJ", "REj7Rzf1", "D92LMRyY", "39EFVFKA", "ODJS9L7Q", "G7G6F7N8"];

export default allowedUserIds;
